import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslocoModule } from '@ngneat/transloco';
import { MaterialModule } from '../material/material.module';
import { DatatableSearchLayoutComponent } from './datatable-search-layout/datatable-search-layout.component';
import { LayoutDialogComponent } from './layout-dialog/layout-dialog.component';
import { LayoutSearchComponent } from './layout-search/layout-search.component';

const exported = [LayoutSearchComponent, LayoutDialogComponent, DatatableSearchLayoutComponent];

@NgModule({
  declarations: [...exported],
  imports: [CommonModule, FlexLayoutModule, MaterialModule, TranslocoModule],
  exports: exported,
})
export class LayoutsModule {}
